import DetailPage from './DetailPage';

const TutorialPage = () => {
  return <DetailPage category={'tutorial'} heading={'title'} />;
};
export default TutorialPage;
